/**
 * Wisdom Cards - Interactive Card Pull Experience
 * Rosebud Woman
 */

(function() {
  'use strict';

  // ==========================================================================
  // Data: 7 Sections
  // ==========================================================================

  // Card back images for variety
  const CARD_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-back.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-purple.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-green.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-teal.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-magenta.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-rosebud.png?v=1769738401',
    'https://cdn.shopify.com/s/files/1/0022/8324/1537/files/card-black.png?v=1769738401'
  ];

  function getRandomCardImage() {
    return CARD_IMAGES[Math.floor(Math.random() * CARD_IMAGES.length)];
  }

  // SVG icons for each section
  const ICONS = {
    // Embodiment & Body Wisdom - Leaf/Plant
    embodiment: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12c0 1.82.49 3.53 1.35 5L12 22l8.65-5A9.96 9.96 0 0022 12c0-5.52-4.48-10-10-10z"/><path d="M12 2c2 3 3 6 3 10s-1 7-3 10"/><path d="M12 2c-2 3-3 6-3 10s1 7 3 10"/><path d="M2 12h20"/></svg>`,
    // Self-Love & Radical Acceptance - Rose
    selflove: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`,
    // Boundaries & Sacred Space - Doorway
    boundaries: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16"/><path d="M9 21v-6h6v6"/><circle cx="15" cy="12" r="1"/></svg>`,
    // Cycles & Transitions - Moon
    cycles: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>`,
    // Pleasure & Sensuality - Flower
    pleasure: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2a4 4 0 014 4c0 1.95-1.4 3.57-3.25 3.93"/><path d="M17.66 6.34a4 4 0 010 5.66c-1.38 1.38-3.56 1.56-5.16.54"/><path d="M20 12a4 4 0 01-4 4c-1.95 0-3.57-1.4-3.93-3.25"/><path d="M17.66 17.66a4 4 0 01-5.66 0c-1.38-1.38-1.56-3.56-.54-5.16"/><path d="M12 20a4 4 0 01-4-4c0-1.95 1.4-3.57 3.25-3.93"/><path d="M6.34 17.66a4 4 0 010-5.66c1.38-1.38 3.56-1.56 5.16-.54"/><path d="M4 12a4 4 0 014-4c1.95 0 3.57 1.4 3.93 3.25"/><path d="M6.34 6.34a4 4 0 015.66 0c1.38 1.38 1.56 3.56.54 5.16"/></svg>`,
    // Surrender & Trust - Water drop
    surrender: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/></svg>`,
    // Integration & Wholeness - Star burst
    integration: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4L2 9.4h7.6z"/></svg>`
  };

  const SECTIONS = [
    {
      id: 1,
      name: "Embodiment & Body Wisdom",
      subtitle: "Roots • Mycelium • The Body as Earth",
      color: "#6B7A5E",
      icon: ICONS.embodiment
    },
    {
      id: 2,
      name: "Self-Love & Radical Acceptance",
      subtitle: "Rose in Bloom • Hands Holding Heart",
      color: "#A66B7A",
      icon: ICONS.selflove
    },
    {
      id: 3,
      name: "Boundaries & Sacred Space",
      subtitle: "Threshold • Guardian • The Temple Door",
      color: "#6B5E7A",
      icon: ICONS.boundaries
    },
    {
      id: 4,
      name: "Cycles & Transitions",
      subtitle: "Moon Phases • Seasons • The Spiral",
      color: "#5E6B7A",
      icon: ICONS.cycles
    },
    {
      id: 5,
      name: "Pleasure & Sensuality",
      subtitle: "Nectar • Honey • The Flowering",
      color: "#8B5A4E",
      icon: ICONS.pleasure
    },
    {
      id: 6,
      name: "Surrender & Trust",
      subtitle: "Water • Flow • The River's Wisdom",
      color: "#5E7A6B",
      icon: ICONS.surrender
    },
    {
      id: 7,
      name: "Integration & Wholeness",
      subtitle: "Weaving • Gold Repair • The Complete Self",
      color: "#7A6B5E",
      icon: ICONS.integration
    }
  ];

  // ==========================================================================
  // Data: 100 Wisdom Cards
  // ==========================================================================

  const CARDS = [
    // Section 1: Embodiment & Body Wisdom (cards 1-14)
    { id: 1, quote: "Your body is not a problem to be solved. It is a mystery to be honored.", author: "Geneen Roth", practiceType: "Somatic", practice: "Place both hands on your heart. Feel its rhythm. Whisper: 'Thank you for carrying me.'", section: 1 },
    { id: 2, quote: "The body keeps the score.", author: "Bessel van der Kolk", practiceType: "Somatic", practice: "Scan your body from crown to toes. Where do you hold tension? Breathe into that place without trying to change it.", section: 1 },
    { id: 3, quote: "Listen to your body when it whispers, so you don't have to hear it scream.", author: "Unknown", practiceType: "Journal", practice: "What has your body been whispering lately that you've been ignoring? Write without judgment.", section: 1 },
    { id: 4, quote: "The body is not a thing, it is a situation.", author: "Simone de Beauvoir", practiceType: "Meditation", practice: "Close your eyes. Rather than thinking about your body, think AS your body. What does it want you to know?", section: 1 },
    { id: 5, quote: "You don't have a soul. You ARE a soul. You have a body.", author: "C.S. Lewis", practiceType: "Ritual", practice: "Anoint your pulse points with oil. As you touch each one, name something your body has survived.", section: 1 },
    { id: 6, quote: "The cure for anything is salt water: sweat, tears, or the sea.", author: "Isak Dinesen", practiceType: "Somatic", practice: "Move your body until you sweat. Dance, walk fast, shake. Let your body release what words cannot.", section: 1 },
    { id: 7, quote: "Your body hears everything your mind says.", author: "Naomi Judd", practiceType: "Journal", practice: "For one day, notice how you speak about your body. Write down 5 things you say. Rewrite each as a blessing.", section: 1 },
    { id: 8, quote: "The body is a sacred garment.", author: "Martha Graham", practiceType: "Ritual", practice: "After your next shower, dry yourself slowly and with reverence, as if drying a temple.", section: 1 },
    { id: 9, quote: "Ground yourself in the body that you have, not the one you wish you had.", author: "Unknown", practiceType: "Somatic", practice: "Stand barefoot on earth. Feel your weight pressing down. You belong here, exactly as you are.", section: 1 },
    { id: 10, quote: "The body is a multilingual being. It speaks through its color and temperature.", author: "Clarissa Pinkola Estés", practiceType: "Meditation", practice: "Notice what temperature your hands are. Cold hands often mean overthinking. Warm them by rubbing together.", section: 1 },
    { id: 11, quote: "Your body is your first home. Learning to feel safe in it is the bravest thing you'll do.", author: "Unknown", practiceType: "Somatic", practice: "Wrap yourself in a blanket. Hum deeply. Feel the vibration through your whole body.", section: 1 },
    { id: 12, quote: "The body has its own way of knowing, a knowing that has little to do with logic.", author: "Gavin de Becker", practiceType: "Journal", practice: "Recall a time you 'just knew' something. Where in your body did you feel that knowing?", section: 1 },
    { id: 13, quote: "Move your body to unlock your mind.", author: "Unknown", practiceType: "Somatic", practice: "Shake your hands vigorously for 30 seconds. Then let them hang heavy. Notice the tingling aliveness.", section: 1 },
    { id: 14, quote: "The body remembers what the mind forgets.", author: "Unknown", practiceType: "Meditation", practice: "Place your hand where you feel most 'you' in your body. Stay there. Breathe. Listen.", section: 1 },

    // Section 2: Self-Love & Radical Acceptance (cards 15-28)
    { id: 15, quote: "You yourself, as much as anybody in the entire universe, deserve your love and affection.", author: "Buddha", practiceType: "Ritual", practice: "Look in a mirror. Say aloud: 'I see you. I accept you. I love you.' Mean it.", section: 2 },
    { id: 16, quote: "Talk to yourself like you would someone you love.", author: "Brené Brown", practiceType: "Journal", practice: "Write a letter to yourself from your wisest, most loving self. What does she want you to know?", section: 2 },
    { id: 17, quote: "No one is you, and that is your superpower.", author: "Unknown", practiceType: "Meditation", practice: "Breathe in, silently say 'I am.' Breathe out, say 'enough.' Repeat until you believe it.", section: 2 },
    { id: 18, quote: "You are imperfect, permanently and inevitably flawed. And you are beautiful.", author: "Amy Bloom", practiceType: "Ritual", practice: "Touch a scar or stretch mark on your body. Thank it for the story it holds.", section: 2 },
    { id: 19, quote: "The most terrifying thing is to accept oneself completely.", author: "Carl Jung", practiceType: "Journal", practice: "What part of yourself do you most resist? Write about her with compassion, as if she were a child.", section: 2 },
    { id: 20, quote: "You are worthy of love and belonging.", author: "Brené Brown", practiceType: "Somatic", practice: "Hug yourself tightly for one full minute. Feel your own arms holding you.", section: 2 },
    { id: 21, quote: "Loving yourself isn't vanity. It's sanity.", author: "Katrina Mayer", practiceType: "Ritual", practice: "Do one thing today purely because it brings YOU joy. Not for productivity. Just pleasure.", section: 2 },
    { id: 22, quote: "Your relationship with yourself sets the tone for every other relationship.", author: "Robert Holden", practiceType: "Journal", practice: "If you were dating yourself, what would you love about you? What would frustrate you? What would you learn?", section: 2 },
    { id: 23, quote: "Be gentle with yourself. You're doing the best you can.", author: "Unknown", practiceType: "Meditation", practice: "Place one hand on your heart, one on your belly. Say: 'May I be kind to myself in this moment.'", section: 2 },
    { id: 24, quote: "The privilege of a lifetime is being who you are.", author: "Joseph Campbell", practiceType: "Journal", practice: "List 10 things that make you weird. Circle the ones you secretly love.", section: 2 },
    { id: 25, quote: "How you love yourself is how you teach others to love you.", author: "Rupi Kaur", practiceType: "Ritual", practice: "Name one way you abandon yourself for others. Commit to stopping for one day.", section: 2 },
    { id: 26, quote: "You've been criticizing yourself for years. Try approving of yourself and see what happens.", author: "Louise Hay", practiceType: "Journal", practice: "Write 20 things you appreciate about yourself. No physical traits. Only qualities and actions.", section: 2 },
    { id: 27, quote: "Self-compassion is simply giving the same kindness to ourselves that we would give to others.", author: "Christopher Germer", practiceType: "Meditation", practice: "Think of someone you love easily. Send yourself the same warmth you feel for them.", section: 2 },
    { id: 28, quote: "You can't hate yourself into a version of yourself you love.", author: "Lori Deschene", practiceType: "Somatic", practice: "Stand tall. Roll your shoulders back. Lift your chin. Feel how your body responds to self-respect.", section: 2 },

    // Section 3: Boundaries & Sacred Space (cards 29-42)
    { id: 29, quote: "Daring to set boundaries is about having the courage to love ourselves.", author: "Brené Brown", practiceType: "Journal", practice: "Where in your life do you say yes when your body says no? Write about one situation honestly.", section: 3 },
    { id: 30, quote: "No is a complete sentence.", author: "Anne Lamott", practiceType: "Somatic", practice: "Practice saying 'No' out loud, in different tones. Firm. Soft. Playful. Feel how each one lives in your body.", section: 3 },
    { id: 31, quote: "You are allowed to take up space.", author: "Unknown", practiceType: "Ritual", practice: "Claim a small space as yours alone today. A chair. A corner. Sit there. Own it.", section: 3 },
    { id: 32, quote: "When we fail to set boundaries, we feel used and mistreated.", author: "Prentis Hemphill", practiceType: "Journal", practice: "What resentment are you carrying? Resentment is a sign of a boundary that needs to be set.", section: 3 },
    { id: 33, quote: "The only people who get upset when you set boundaries are the ones who benefited from you having none.", author: "Unknown", practiceType: "Meditation", practice: "Visualize a soft golden light around your body. This is your energetic boundary. Strengthen it with each breath.", section: 3 },
    { id: 34, quote: "Your body is your temple. Guard it.", author: "Unknown", practiceType: "Ritual", practice: "Before answering any request today, pause. Ask your body: 'Do I have capacity for this?' Honor the answer.", section: 3 },
    { id: 35, quote: "Givers need to set limits because takers rarely do.", author: "Rachel Wolchin", practiceType: "Journal", practice: "List the people who drain you. What do they take? What boundary could protect your energy?", section: 3 },
    { id: 36, quote: "Clear is kind. Unclear is unkind.", author: "Brené Brown", practiceType: "Somatic", practice: "Notice where you feel murky in relationships. Your body knows. Clarity is a gift to both parties.", section: 3 },
    { id: 37, quote: "You teach people how to treat you.", author: "Phil McGraw", practiceType: "Journal", practice: "How have you taught someone to treat you poorly by not speaking up? What would you do differently?", section: 3 },
    { id: 38, quote: "Your peace is more important than their comfort.", author: "Unknown", practiceType: "Meditation", practice: "Picture a situation where you need a boundary. Imagine setting it. Feel the relief in your body.", section: 3 },
    { id: 39, quote: "The fence that protects the garden doesn't hate the flowers.", author: "Unknown", practiceType: "Ritual", practice: "Write one boundary you need to set on paper. Burn it or bury it as a commitment to yourself.", section: 3 },
    { id: 40, quote: "You don't owe anyone an explanation for protecting your energy.", author: "Unknown", practiceType: "Somatic", practice: "Cross your arms over your chest and hug your shoulders. Say: 'My energy is precious. I choose where it goes.'", section: 3 },
    { id: 41, quote: "Love yourself enough to set boundaries.", author: "Unknown", practiceType: "Journal", practice: "What would your life look like if you protected your time as fiercely as you protect others' feelings?", section: 3 },
    { id: 42, quote: "Sometimes the most spiritual thing you can do is take a nap.", author: "Unknown", practiceType: "Ritual", practice: "Today, cancel one thing that doesn't serve you. Rest in that reclaimed time without guilt.", section: 3 },

    // Section 4: Cycles & Transitions (cards 43-57)
    { id: 43, quote: "And the day came when the risk to remain tight in a bud was more painful than the risk it took to blossom.", author: "Anaïs Nin", practiceType: "Journal", practice: "What are you ready to let go of? What wants to be born through you?", section: 4 },
    { id: 44, quote: "The only way out is through.", author: "Robert Frost", practiceType: "Meditation", practice: "Breathe into the difficulty you're facing. Don't push it away. Say: 'I am moving through this.'", section: 4 },
    { id: 45, quote: "This too shall pass.", author: "Persian Proverb", practiceType: "Ritual", practice: "Light a candle. Watch the flame dance. Know that everything, even this moment, is temporary.", section: 4 },
    { id: 46, quote: "In the depth of winter, I finally learned that within me there lay an invincible summer.", author: "Albert Camus", practiceType: "Journal", practice: "What season of life are you in? What does this season require of you?", section: 4 },
    { id: 47, quote: "She was unstoppable, not because she didn't have failures, but because she continued on despite them.", author: "Beau Taplin", practiceType: "Somatic", practice: "Stand up. Fall down (safely). Get up. Repeat. Feel the resilience in your body.", section: 4 },
    { id: 48, quote: "The wound is the place where the Light enters you.", author: "Rumi", practiceType: "Meditation", practice: "Visualize golden light pouring into your deepest wound. It is not broken—it is where you're most open.", section: 4 },
    { id: 49, quote: "You have survived 100% of your worst days.", author: "Unknown", practiceType: "Journal", practice: "Make a survival list. Every hard thing you've lived through. You are still here.", section: 4 },
    { id: 50, quote: "Growth is painful. Change is painful. But nothing is as painful as staying stuck.", author: "Unknown", practiceType: "Somatic", practice: "Where do you feel stuck in your body? Move that part. Shake it. Remind it that movement is possible.", section: 4 },
    { id: 51, quote: "Just when the caterpillar thought the world was over, it became a butterfly.", author: "Chuang Tzu", practiceType: "Ritual", practice: "Wrap yourself in a blanket cocoon. Stay there for 5 minutes. Emerge slowly, stretching new wings.", section: 4 },
    { id: 52, quote: "You are not what happened to you. You are what you choose to become.", author: "Carl Jung", practiceType: "Journal", practice: "How has your hardest experience shaped who you're becoming? What gift came from the pain?", section: 4 },
    { id: 53, quote: "The snake which cannot cast its skin has to die.", author: "Friedrich Nietzsche", practiceType: "Ritual", practice: "What skin are you ready to shed? Name it. Thank it for protecting you. Release it.", section: 4 },
    { id: 54, quote: "Everything you want is on the other side of fear.", author: "Jack Canfield", practiceType: "Meditation", practice: "Breathe into your fear. Ask it: 'What are you protecting?' Thank it. Then take one small step anyway.", section: 4 },
    { id: 55, quote: "Honor the space between no longer and not yet.", author: "Nancy Levin", practiceType: "Somatic", practice: "Stand in a doorway. Feel the threshold. You are between worlds. Both are valid.", section: 4 },
    { id: 56, quote: "The moon does not fight. It attacks no one. And yet the tides obey.", author: "Deng Ming-Dao", practiceType: "Meditation", practice: "Tonight, look at the moon (or picture it). Let its phases remind you that waxing and waning are both holy.", section: 4 },
    { id: 57, quote: "We must be willing to let go of the life we planned so as to have the life that is waiting for us.", author: "Joseph Campbell", practiceType: "Journal", practice: "What plan are you gripping too tightly? What might open if you released it?", section: 4 },

    // Section 5: Pleasure & Sensuality (cards 58-71)
    { id: 58, quote: "Pleasure is a birthright, not a reward.", author: "Adrienne Maree Brown", practiceType: "Ritual", practice: "Do one pleasurable thing today that serves no purpose except joy.", section: 5 },
    { id: 59, quote: "Your body is not a machine. It is an exquisite garden.", author: "Unknown", practiceType: "Somatic", practice: "Touch your skin slowly with oil. Awaken the thousands of nerve endings longing for attention.", section: 5 },
    { id: 60, quote: "The body is meant to be seen, not all covered up.", author: "Marilyn Monroe", practiceType: "Ritual", practice: "Spend 5 minutes naked, just being in your body. Notice what you see with curiosity, not judgment.", section: 5 },
    { id: 61, quote: "Sensuality is an intelligence of the body.", author: "Unknown", practiceType: "Meditation", practice: "Close your eyes. Listen to music that makes you feel something. Let your body respond however it wants.", section: 5 },
    { id: 62, quote: "Your desires are holy.", author: "Unknown", practiceType: "Journal", practice: "Write about a desire you've been ashamed of. What if it's actually guiding you toward wholeness?", section: 5 },
    { id: 63, quote: "The skin is the largest organ. Honor it.", author: "Unknown", practiceType: "Somatic", practice: "Brush your skin with a dry brush. Feel every square inch. Wake up.", section: 5 },
    { id: 64, quote: "How we do pleasure is how we do everything.", author: "Unknown", practiceType: "Journal", practice: "How do you typically receive pleasure? Rushed? Guilty? Fully? What does that reveal?", section: 5 },
    { id: 65, quote: "The body asks for sweetness.", author: "Unknown", practiceType: "Ritual", practice: "Eat something delicious slowly. Close your eyes. Let it be a meditation.", section: 5 },
    { id: 66, quote: "You are allowed to want what you want.", author: "Unknown", practiceType: "Meditation", practice: "Place your hand on your lower belly. Ask: 'What do you want?' Listen without censoring.", section: 5 },
    { id: 67, quote: "Sensuality and spirituality are the same thing.", author: "Unknown", practiceType: "Somatic", practice: "Take a bath or shower in candlelight. Make it sacred. Make it slow.", section: 5 },
    { id: 68, quote: "The rose that blooms does not apologize for being beautiful.", author: "Unknown", practiceType: "Ritual", practice: "Wear something that makes you feel beautiful today. Just for you.", section: 5 },
    { id: 69, quote: "Your pleasure is not negotiable.", author: "Unknown", practiceType: "Journal", practice: "When did you learn that your pleasure was less important than others' needs? Write that story, then rewrite it.", section: 5 },
    { id: 70, quote: "The erotic is a resource within each of us.", author: "Audre Lorde", practiceType: "Meditation", practice: "Think of something that makes you feel alive. Breathe into that feeling. Let it spread through you.", section: 5 },
    { id: 71, quote: "Self-pleasure is self-care.", author: "Unknown", practiceType: "Ritual", practice: "Touch yourself with the same reverence you'd touch a lover. You deserve that tenderness.", section: 5 },

    // Section 6: Surrender & Trust (cards 72-85)
    { id: 72, quote: "Surrender is not giving up. It is giving over.", author: "Unknown", practiceType: "Meditation", practice: "Lie flat on the ground. Feel the earth holding you. You don't have to hold yourself up right now.", section: 6 },
    { id: 73, quote: "Let go or be dragged.", author: "Zen Proverb", practiceType: "Journal", practice: "What are you white-knuckling? What would happen if you just... let go?", section: 6 },
    { id: 74, quote: "The universe is not punishing you. It is redirecting you.", author: "Unknown", practiceType: "Meditation", practice: "Think of a door that closed. What opened instead? Trust that the same is happening now.", section: 6 },
    { id: 75, quote: "Trust the wait. Embrace the uncertainty.", author: "Mandy Hale", practiceType: "Somatic", practice: "Unclench your jaw. Soften your shoulders. Unfurrow your brow. Now take a breath.", section: 6 },
    { id: 76, quote: "The river doesn't push itself downstream.", author: "Unknown", practiceType: "Ritual", practice: "Pour water slowly from one vessel to another. Watch how it finds its way without force.", section: 6 },
    { id: 77, quote: "What you resist persists.", author: "Carl Jung", practiceType: "Journal", practice: "What are you fighting against? What if you stopped fighting and started flowing?", section: 6 },
    { id: 78, quote: "You cannot see your reflection in running water.", author: "Lao Tzu", practiceType: "Meditation", practice: "Be still for 5 minutes. No phone. No tasks. Let your inner waters settle.", section: 6 },
    { id: 79, quote: "Faith is taking the first step even when you don't see the whole staircase.", author: "Martin Luther King Jr.", practiceType: "Somatic", practice: "Close your eyes and take 10 steps forward. Trust you won't fall. Open your eyes. You didn't.", section: 6 },
    { id: 80, quote: "The softer you become, the harder it is to break you.", author: "Unknown", practiceType: "Journal", practice: "Where has your softness been your strength? When has hardness made things worse?", section: 6 },
    { id: 81, quote: "Stop trying to make something happen. Instead, let something happen.", author: "Unknown", practiceType: "Meditation", practice: "Sit with no agenda. Ask nothing. Do nothing. Just be. See what arises.", section: 6 },
    { id: 82, quote: "Grace means that all of your mistakes now serve a purpose.", author: "Unknown", practiceType: "Journal", practice: "Name a mistake you regret. How has it served you? What did it teach?", section: 6 },
    { id: 83, quote: "You are being held by something larger than yourself.", author: "Unknown", practiceType: "Somatic", practice: "Lean back in your chair. Let it hold you completely. Let something else support your weight.", section: 6 },
    { id: 84, quote: "When nothing is certain, everything is possible.", author: "Unknown", practiceType: "Ritual", practice: "Write your worry on a leaf or paper. Place it in moving water (stream, drain). Watch it disappear.", section: 6 },
    { id: 85, quote: "Trust the timing of your life.", author: "Unknown", practiceType: "Meditation", practice: "Think of something you wanted that came late—and it was perfect timing. Trust again.", section: 6 },

    // Section 7: Integration & Wholeness (cards 86-100)
    { id: 86, quote: "You are not broken. You are breaking open.", author: "Unknown", practiceType: "Journal", practice: "Where are you cracking? What light is coming through those cracks?", section: 7 },
    { id: 87, quote: "Kintsugi: The art of repairing with gold. Your cracks are what make you precious.", author: "Japanese Proverb", practiceType: "Ritual", practice: "Touch a scar on your body. Imagine filling it with gold. It's not a flaw—it's where you shine.", section: 7 },
    { id: 88, quote: "The goal is not perfection. It is wholeness.", author: "Unknown", practiceType: "Meditation", practice: "Breathe in: 'I am whole.' Breathe out: 'I am complete.' Repeat until you feel it.", section: 7 },
    { id: 89, quote: "Your dark and your light are equally holy.", author: "Unknown", practiceType: "Journal", practice: "Write a love letter to your shadow self. The parts you hide. They need love too.", section: 7 },
    { id: 90, quote: "Integration is when all parts of you can sit at the same table.", author: "Unknown", practiceType: "Meditation", practice: "Invite all versions of yourself to a mental meeting. The scared one. The angry one. The joyful one. Let them be.", section: 7 },
    { id: 91, quote: "You contain multitudes.", author: "Walt Whitman", practiceType: "Journal", practice: "List 10 contradictions within yourself. You are both things. That's not hypocrisy—it's humanity.", section: 7 },
    { id: 92, quote: "Healing happens when you accept all of yourself.", author: "Unknown", practiceType: "Somatic", practice: "Place your hands on a part of your body you struggle with. Send it love. It's part of you.", section: 7 },
    { id: 93, quote: "We are all just walking each other home.", author: "Ram Dass", practiceType: "Meditation", practice: "Think of someone who has helped you. Send them silent gratitude. We do not heal alone.", section: 7 },
    { id: 94, quote: "The privilege of a lifetime is to become who you truly are.", author: "Carl Jung", practiceType: "Journal", practice: "Who are you becoming? Not who you think you should be. Who are you actually growing into?", section: 7 },
    { id: 95, quote: "Your story isn't over yet. New chapters are being written.", author: "Unknown", practiceType: "Ritual", practice: "Open a book to a random page. Let the first sentence you see be a message for your next chapter.", section: 7 },
    { id: 96, quote: "You are the medicine you've been looking for.", author: "Unknown", practiceType: "Somatic", practice: "Place your hands on your belly. Feel the warmth. You have everything you need inside you.", section: 7 },
    { id: 97, quote: "Don't ask what the world needs. Ask what makes you come alive.", author: "Howard Thurman", practiceType: "Journal", practice: "When do you feel most alive? How can you do more of that?", section: 7 },
    { id: 98, quote: "We are not human beings having a spiritual experience. We are spiritual beings having a human experience.", author: "Pierre Teilhard de Chardin", practiceType: "Meditation", practice: "Close your eyes. Sense the ancient part of you that has always existed. She is wise. Listen.", section: 7 },
    { id: 99, quote: "The wound is where the light enters.", author: "Rumi", practiceType: "Ritual", practice: "Write down your deepest wound. Fold the paper. Hold it to your heart. Say: 'This is where I became wise.'", section: 7 },
    { id: 100, quote: "You are exactly where you need to be.", author: "Unknown", practiceType: "Somatic", practice: "Stand still. Feel your feet. Say: 'I am here. I am whole. I am home.' Because you are.", section: 7 }
  ];

  // ==========================================================================
  // State Management
  // ==========================================================================

  let state = {
    mode: 'choose',           // choose, sections, shuffling, spread, revealed
    selectedSection: null,    // null for surrender (all cards), or section id
    currentCards: [],         // 7 cards for spread
    selectedCard: null,       // the revealed card
    previousSection: null     // for "pull again" in same realm
  };

  // ==========================================================================
  // DOM References
  // ==========================================================================

  let elements = {};

  function initElements() {
    elements = {
      app: document.getElementById('wisdomCards'),
      backBtn: document.getElementById('wisdomBackBtn'),
      // Landing state
      landing: document.getElementById('wisdomLanding'),
      surrenderBtn: document.getElementById('surrenderBtn'),
      intentionalBtn: document.getElementById('intentionalBtn'),
      // Section selection state
      sections: document.getElementById('wisdomSections'),
      sectionsGrid: document.getElementById('sectionsGrid'),
      backToChoose: document.getElementById('backToChoose'),
      // Shuffling state
      shuffling: document.getElementById('wisdomShuffling'),
      shuffleText: document.getElementById('shuffleText'),
      // Spread state
      spread: document.getElementById('wisdomSpread'),
      spreadContainer: document.getElementById('spreadContainer'),
      spreadBackBtn: document.getElementById('spreadBackBtn'),
      // Revealed state
      revealed: document.getElementById('wisdomRevealed'),
      cardInner: document.getElementById('cardInner'),
      cardSectionName: document.getElementById('cardSectionName'),
      cardQuote: document.getElementById('cardQuote'),
      cardAuthor: document.getElementById('cardAuthor'),
      cardPracticeType: document.getElementById('cardPracticeType'),
      cardPractice: document.getElementById('cardPractice'),
      cardNumber: document.getElementById('cardNumber'),
      // Action buttons
      pullAgainBtn: document.getElementById('pullAgainBtn'),
      newReadingBtn: document.getElementById('newReadingBtn'),
      shareBtn: document.getElementById('shareBtn'),
      // Toast
      toast: document.getElementById('wisdomToast')
    };
  }

  // ==========================================================================
  // State Transitions
  // ==========================================================================

  function setState(newMode) {
    state.mode = newMode;
    elements.app.setAttribute('data-state', newMode);
  }

  function goToChoose() {
    state.selectedSection = null;
    state.currentCards = [];
    state.selectedCard = null;
    setState('choose');
  }

  function goToSections() {
    setState('sections');
  }

  function goToShuffling(sectionId) {
    state.selectedSection = sectionId;
    state.previousSection = sectionId;

    // Randomize shuffle card images
    const shuffleCards = document.querySelectorAll('.wisdom-cards__shuffle-card');
    shuffleCards.forEach(card => {
      card.style.backgroundImage = `url('${getRandomCardImage()}')`;
    });

    // Set shuffle text
    if (sectionId === null) {
      elements.shuffleText.textContent = 'Surrendering to the universe...';
    } else {
      const section = SECTIONS.find(s => s.id === sectionId);
      elements.shuffleText.textContent = `Drawing from ${section.name}...`;
    }

    setState('shuffling');

    // Auto-transition to spread after 3.5 seconds
    setTimeout(() => {
      selectRandomCards();
      goToSpread();
    }, 3500);
  }

  function selectRandomCards() {
    // Filter cards by section if intentional pull
    let pool = state.selectedSection === null
      ? CARDS
      : CARDS.filter(c => c.section === state.selectedSection);

    // Shuffle and pick 7
    const shuffled = [...pool].sort(() => Math.random() - 0.5);
    state.currentCards = shuffled.slice(0, 7);
  }

  function goToSpread() {
    setState('spread');
    renderSpreadCards();
  }

  function goToRevealed(cardIndex) {
    state.selectedCard = state.currentCards[cardIndex];
    setState('revealed');
    renderRevealedCard();
  }

  // ==========================================================================
  // Render Functions
  // ==========================================================================

  function renderSectionButtons() {
    elements.sectionsGrid.innerHTML = SECTIONS.map(section => `
      <button
        class="wisdom-cards__section-btn"
        data-section="${section.id}"
        style="--section-color: ${section.color}"
      >
        <span class="wisdom-cards__section-icon">${section.icon}</span>
        <span class="wisdom-cards__section-name">${section.name}</span>
        <span class="wisdom-cards__section-subtitle">${section.subtitle}</span>
      </button>
    `).join('');
  }

  function renderSpreadCards() {
    elements.spreadContainer.innerHTML = state.currentCards.map((card, index) => {
      const section = SECTIONS.find(s => s.id === card.section);
      const cardImage = getRandomCardImage();
      return `
        <button
          class="wisdom-cards__spread-card"
          data-card-index="${index}"
          style="--card-color: ${section.color}; --card-color-dark: ${darkenColor(section.color, 0.2)}; background-image: url('${cardImage}')"
          aria-label="Select card ${index + 1}"
        ></button>
      `;
    }).join('');
  }

  function renderRevealedCard() {
    const card = state.selectedCard;
    const section = SECTIONS.find(s => s.id === card.section);

    elements.cardSectionName.textContent = section.name;
    elements.cardSectionName.style.color = section.color;

    elements.cardQuote.textContent = `"${card.quote}"`;
    elements.cardAuthor.textContent = `— ${card.author}`;

    elements.cardPracticeType.textContent = card.practiceType;
    elements.cardPracticeType.setAttribute('data-practice', card.practiceType.toLowerCase());
    elements.cardPractice.textContent = card.practice;

    // Show card number
    if (elements.cardNumber) {
      elements.cardNumber.textContent = `${card.id} / 100`;
    }

    // Reset animation by forcing reflow
    elements.cardInner.style.animation = 'none';
    elements.cardInner.offsetHeight;
    elements.cardInner.style.animation = '';
  }

  // ==========================================================================
  // Share Functionality
  // ==========================================================================

  async function shareCard() {
    const card = state.selectedCard;
    const section = SECTIONS.find(s => s.id === card.section);

    const shareText = `"${card.quote}" — ${card.author}\n\n✦ ${section.name}\n\nPractice: ${card.practice}\n\nPull your own wisdom card at`;
    const shareUrl = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Wisdom Card',
          text: shareText,
          url: shareUrl
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          copyToClipboard(shareText + ' ' + shareUrl);
        }
      }
    } else {
      copyToClipboard(shareText + ' ' + shareUrl);
    }
  }

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      showToast('Copied to clipboard!');
    }).catch(() => {
      showToast('Unable to copy');
    });
  }

  function showToast(message) {
    elements.toast.textContent = message;
    elements.toast.classList.add('visible');
    setTimeout(() => {
      elements.toast.classList.remove('visible');
    }, 2500);
  }

  // ==========================================================================
  // Utility Functions
  // ==========================================================================

  function darkenColor(hex, percent) {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent * 100);
    const R = Math.max((num >> 16) - amt, 0);
    const G = Math.max((num >> 8 & 0x00FF) - amt, 0);
    const B = Math.max((num & 0x0000FF) - amt, 0);
    return '#' + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
  }

  // ==========================================================================
  // Event Handlers
  // ==========================================================================

  function handleBackClick() {
    switch (state.mode) {
      case 'sections':
        goToChoose();
        break;
      case 'spread':
        state.selectedSection === null ? goToChoose() : goToSections();
        break;
      case 'revealed':
        goToSpread();
        break;
      default:
        // On choose screen, back does nothing or could link to main site
        break;
    }
  }

  function handleSurrender() {
    goToShuffling(null);
  }

  function handleIntentional() {
    goToSections();
  }

  function handleSectionSelect(e) {
    const btn = e.target.closest('[data-section]');
    if (btn) {
      const sectionId = parseInt(btn.dataset.section);
      goToShuffling(sectionId);
    }
  }

  function handleSpreadCardSelect(e) {
    const card = e.target.closest('[data-card-index]');
    if (card) {
      const index = parseInt(card.dataset.cardIndex);
      goToRevealed(index);
    }
  }

  function handlePullAgain() {
    goToShuffling(state.previousSection);
  }

  function handleNewReading() {
    goToChoose();
  }

  function handleShare() {
    shareCard();
  }

  // ==========================================================================
  // Initialization
  // ==========================================================================

  function init() {
    initElements();
    if (!elements.app) return;

    renderSectionButtons();

    // Event listeners
    elements.backBtn.addEventListener('click', handleBackClick);
    elements.surrenderBtn.addEventListener('click', handleSurrender);
    elements.intentionalBtn.addEventListener('click', handleIntentional);
    elements.sectionsGrid.addEventListener('click', handleSectionSelect);
    elements.spreadContainer.addEventListener('click', handleSpreadCardSelect);
    elements.pullAgainBtn.addEventListener('click', handlePullAgain);
    elements.newReadingBtn.addEventListener('click', handleNewReading);
    elements.shareBtn.addEventListener('click', handleShare);

    // New back links
    if (elements.backToChoose) {
      elements.backToChoose.addEventListener('click', goToChoose);
    }
    if (elements.spreadBackBtn) {
      elements.spreadBackBtn.addEventListener('click', goToChoose);
    }

    // Set initial state
    setState('choose');
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
